import queryString from 'query-string';

/**
 * Decide whether the "Audiobook (beta)" menu entry should open the paid-beta
 * TEASER modal (true) or route to the real feature (false).
 *
 * - No generation access (`audiobookEnabled` false) → teaser when the book has
 *   no existing audio. The caller first gives existing renditions their
 *   author-management surface, which is independent of the generation flag.
 * - Has access → the real feature… UNLESS the `?audiobookTeaser=1` QA override is
 *   present, which forces the teaser so it can be previewed even where the
 *   `audiobook` flag is globally on (e.g. staging) — without flipping the flag or
 *   needing a no-access account. The override only opens a modal against the
 *   author's own book; it grants nothing.
 *
 * See docs/features/audiobooks/beta-teaser.md.
 */
export const shouldOpenAudiobookTeaser = (
  audiobookEnabled: boolean,
  locationSearch: string
): boolean => {
  const forceTeaser =
    queryString.parse(locationSearch || '').audiobookTeaser === '1';
  return !audiobookEnabled || forceTeaser;
};
